import type { UnknownAction } from '@reduxjs/toolkit';

import * as actions from './bumpActions';
import { type BumpStore, mkBumpStore } from './bumpTypes';

const bumpReducer = (state: BumpStore = mkBumpStore(), action: UnknownAction): BumpStore => {
  switch (true) {
    case actions.setBumpSocketState.match(action):
      return state.merge({ socketState: action.payload });
    default:
      return state;
  }
};

export default bumpReducer;
